import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import UserLayout from '../../Shared/UserLayout';
import DataContainer from '../../Shared/DataContainer';
import DropdownButton from '../../Shared/DropdownButton';
import Pagination from '../../Shared/Pagination';
import TextInput from '../../Shared/TextInput';
import LoadingButton from '../../Shared/LoadingButton';
import Icon from '../../Shared/Icon';
import { can } from '../../utils';

const Cart = () => {
     const { auth, errors, data } = usePage().props;
     const [proforma, setProforma] = useState(false);
     const [sending, setSending] = useState(false);
     const [email, setEmail] = useState(false);
     const [values, setValues] = useState({
          cart: (data.cart)?data.cart.id:0,
          details: (data.cart)?data.cart.details:[]
     });

     function handleChange(e, index) {
          e.persist();
          const value = e.target.value;
          let details = values.details;
          details[index].quantity = value;
          details[index]['update'] = true;
          setValues(values => ({
               ...values,
               details: details
          }));
     }

     function handleChangeProforma(e) {
          e.preventDefault();
          setProforma(!proforma);
     }

     function handleUpdate(e, id, qty) {
          e.preventDefault();
          values['quantity'] = qty;
          values['id'] = id;
          Inertia.post(route('cart.add'), values, { preserveState: false }).then(() => {
               // setSending(false);
          });
     }

     function handleDelete(e, id,) {
          e.preventDefault();
          values['id'] = id;
          Inertia.post(route('cart.remove'), values, { preserveState: false }).then(() => {
               // setSending(false);
          });
     }

     function handleSubmitProforma(e) {
          e.preventDefault();
          Inertia.post(route('site.cart.proforma', data.cart.id), {email: email}, { preserveState: false }).then(() => {
               // setSending(false);
          });
     }

     return (
          <React.Fragment key="security-index">
               <Helmet>
                    <title>{data.caption.title}</title>
               </Helmet>
               <div className="max-w-7xl mx-auto p-2">
                    <InertiaLink className="font-semibold text-md text-gray-700 hover:text-gray-800 leading-tight" href={route('home')}>Dashboard</InertiaLink> | <span className="text-md text-gray-700 leading-tight">{data.caption.title}</span>
               </div>
               {!data.cart && (<div className="rounded col-span-12 bg-blue-100 text-blue-600 border border-blue-500 px-4 py-4 text-center" dangerouslySetInnerHTML={{ __html: data.caption.empty}}></div>)}
               {data.cart && (<div className="flex justify-center my-6">
                    <div className="flex flex-col w-full p-8 text-gray-800 bg-white shadow-lg pin-r pin-y md:w-4/5 lg:w-4/5">
                         <div className="flex-1">
                              <div className="w-full bg-gray-200 text-gray-500 px-3 py-3">
                                   <span className="font-semibold">{data.caption.title} No. :</span> {data.cart.number} | <span className="font-semibold">Date : {data.cart.created}</span>
                              </div>
                              <table className="w-full text-sm lg:text-base" cellSpacing="0">
                                   <thead>
                                        <tr className="h-12 uppercase">
                                             <th className="hidden md:table-cell"></th>
                                             <th className="text-left">{data.caption.product}</th>
                                             <th className="lg:text-right text-left pl-5 lg:pl-0">
                                                  <span className="lg:hidden" title="Quantity">{data.caption.short_qty}</span>
                                                  <span className="hidden lg:inline">{data.caption.quantity}</span>
                                             </th>
                                             <th className="hidden text-right md:table-cell">{data.caption.price}</th>
                                             <th className="text-right">{data.caption.total_price}</th>
                                        </tr>
                                   </thead>
                                   <tbody>
                                        {values.details.map(({id, name, code, product, quantity, currency, price, promotion, total, packs, image, update, is_available, available_msg}, i) => {
                                             return <tr className={`pt-4 border-b border-gray-300 ${!is_available?'bg-gray-100':''}`} key={id}>
                                                  <td className="hidden pb-4 md:table-cell">
                                                       <a href="#">
                                                            {image && (<img src={image} alt={name} className="w-20 rounded" alt="Thumbnail" />)}
                                                            {!image && (<img className="w-20" src={`https://ui-avatars.com/api/?name=${name}&amp;color=7F9CF5&amp;background=EBF4FF`} alt={name} />)}
                                                       </a>
                                                  </td>
                                                  <td>
                                                       <a href="#">
                                                            <p className="mb-2 md:ml-4">{name} <span className="text-xs text-gray-500">({code})</span></p>
                                                            {packs && (<span className="ml-4 text-xs text-gray-600">{packs.join(' | ')}</span>)}
                                                            {is_available && (<form onSubmit={(e)=>handleDelete(e, product)}>
                                                                 <button type="submit" className="text-red-700 md:ml-4">
                                                                      <small>{data.caption.remove}</small>
                                                                 </button>
                                                            </form>)}
                                                            {!is_available && (<small className="text-red-700 md:ml-4">{available_msg}</small>)}
                                                       </a>
                                                  </td>
                                                  <td className="justify-center md:justify-end md:flex mt-6">
                                                       <div className="w-20">
                                                            <div className="relative flex flex-row w-full h-8">
                                                                 {is_available && (<input type="number" onChange={(e)=>handleChange(e, i)} value={quantity} className="w-full font-semibold text-center text-gray-700 bg-gray-200 outline-none focus:outline-none hover:text-black focus:text-black" />)}
                                                                 {!is_available && (<span>{quantity}</span>)}
                                                            </div>
                                                            {update && is_available && (<form onSubmit={(e)=>handleUpdate(e, product, quantity)}>
                                                                 <div>
                                                                      <button type="submit" className="text-blue-700 md:ml-4">
                                                                           <small>{data.caption.modify}</small>
                                                                      </button>
                                                                 </div>
                                                            </form>)}
                                                       </div>
                                                  </td>
                                                  <td className="hidden text-right md:table-cell">
                                                       <span className={`${promotion?'text-sm text-gray-500 line-through':'text-sm lg:text-base'} font-medium`}>{currency} {price.toFixed(2)}</span><br />
                                                       {(promotion > 0) && (<span className="text-sm lg:text-base font-medium">{currency} {promotion.toFixed(2)}</span>)}
                                                  </td>
                                                  <td className="text-right">
                                                       <span className="text-sm lg:text-base font-medium">{currency} {total.toFixed(2)}</span>
                                                  </td>
                                             </tr>
                                        })}
                                   </tbody>
                              </table>
                              <hr />
                              <div className="mt-4 float-right lg:px-2 lg:w-1/2">
                                   {/*<div className="p-4 bg-gray-100 rounded-full">
                                        <h1 className="ml-2 font-bold uppercase">Order Details</h1>
                                   </div>*/}
                                   <div className="p-4">
                                        <div className="flex justify-between border-b">
                                             <div className="lg:px-4 lg:py-2 m-2 text-lg lg:text-xl font-bold text-center text-gray-800">
                                                  {data.caption.total}
                                             </div>
                                             <div className="lg:px-4 lg:py-2 m-2 lg:text-lg font-bold text-center text-gray-900">
                                                  {data.cart.currency} {data.cart.amount.toFixed(2)}
                                             </div>
                                        </div>
                                        <div className="p-4 mt-4 bg-gray-100 rounded-full">
                                             <label className="flex items-center" htmlFor="moncash">
                                                  <input name="pay_method" className="form-checkbox" type="checkbox" value={proforma} onChange={e=>setProforma(!proforma)}/>
                                                  <span className="ml-2 text-md font-bold text-gray-500">{data.caption.proforma}</span>
                                             </label>
                                        </div>
                                        {proforma && (<form onSubmit={handleSubmitProforma}>
                                             <TextInput
                                                  className="form-input rounded-md shadow-sm mt-4 block w-full"
                                                  label={data.caption.email}
                                                  name="email"
                                                  type="text"
                                                  disable={false}
                                                  readonly={false}
                                                  errors={errors.email}
                                                  value={values.email}
                                                  onChange={e=>setEmail(e.target.value)}
                                             />
                                             <LoadingButton type="submit" loading={sending} className={`flex justify-center w-full px-10 py-3 mt-4 font-medium text-white uppercase bg-emerald-800 rounded-full shadow item-center hover:bg-emerald-600 focus:shadow-outline focus:outline-none`}>
                                                  {data.caption.send}
                                             </LoadingButton>
                                        </form>)}
                                        {/*<div className="flex justify-between pt-4 border-b">
                                             <div className="lg:px-4 lg:py-2 m-2 text-lg lg:text-xl font-bold text-center text-gray-800">
                                                  Tax
                                             </div>
                                             <div className="lg:px-4 lg:py-2 m-2 lg:text-lg font-bold text-center text-gray-900">
                                                  2,976.55€
                                             </div>
                                        </div>
                                        <div className="flex justify-between pt-4 border-b">
                                             <div className="lg:px-4 lg:py-2 m-2 text-lg lg:text-xl font-bold text-center text-gray-800">
                                                  Total
                                             </div>
                                             <div className="lg:px-4 lg:py-2 m-2 lg:text-lg font-bold text-center text-gray-900">
                                                  17,859.3€
                                             </div>
                                        </div>*/}
                                        {!proforma && (<a href={route('payment.index', values.cart)}>
                                             <button className="flex justify-center w-full px-10 py-3 mt-6 font-medium text-white uppercase bg-emerald-800 rounded-full shadow item-center hover:bg-emerald-600 focus:shadow-outline focus:outline-none">
                                                  <span className="ml-2 mt-5px">{data.caption.proceed_payment}</span>
                                             </button>
                                        </a>)}
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>)}
          </React.Fragment>
     );
};

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
Cart.layout = page => <UserLayout children={page} header={'Cart'} />;

export default Cart;
